module.exports = __webpack_public_path__ + "487ef1c8b75a5950ecc12052bbc4a67c.svg";